<template>
  <div class="tabberWarp">
    <div class="warp">
      <Item :txt='item.txt' :page='item.page' @change='getVal' :key="item.txt" v-for="item in tabbarDes"
            :sel="$route.name">
        <img :src="item.normalImg" slot='normalImg' alt="">
        <img :src="item.activeImg" slot='activeImg' alt="">
      </Item>
    </div>
  </div>
</template>
<script type="text/javascript">
import Item from './Item'

export default {
  components: {
    Item
  },
  data: function () {
    return {
      tabbarDes: [
        {
          txt: '生日',
          page: 'm_birthday',
          normalImg: require('../assets/images/32/icon_birthday.png'),
          activeImg: require('../assets/images/32/icon_birthday_selected.png')

        },
        {
          txt: '圈子',
          page: 'm_circle',
          normalImg: require('../assets/images/32/icon_friends.png'),
          activeImg: require('../assets/images/32/icon_friends_selected.png')
        },
        {
          txt: '工具',
          page: 'm_tool',
          normalImg: require('../assets/images/32/icon_tools.png'),
          activeImg: require('../assets/images/32/icon_tools_selected.png')
        },
        {
          txt: '轨迹',
          page: 'm_moment',
          normalImg: require('../assets/images/32/icon_moment.png'),
          activeImg: require('../assets/images/32/icon_moment_selected.png')
        },
        {
          txt: '我的',
          page: 'm_mine',
          normalImg: require('../assets/images/32/mine.png'),
          activeImg: require('../assets/images/32/mine_selected.png')
        }
      ]
    }
  },
  methods: {
    getVal: function (res) {
      this.selectedMenu = res;
    }
  }
}
</script>
<style type="text/css">
.warp {
  width: 100%;
  border-top: 1px solid #eee;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: space-around;
  font-size: 0;
}

.warp img {
  width: 20px;
  height: 20px;
}

.tabberWarp img {
  margin-top: 10px;
  margin-bottom: 5px;

}

.tabberWarp {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  padding-bottom: 5px;
  background: #fff;
}
</style>
